import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_the_footer = _resolveComponent("the-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, {
        class: "center-container",
        style: { padding: '75px 50px 20px 50px', margin: 0, minHeight: '720px' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "用户登录",
            hoverable: false,
            bordered: true,
            style: {"width":"520px"},
            bodyStyle: { padding: '25px' },
            type: 'inner',
            class: "card"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: _ctx.loginUser,
                "label-col": { span: 6 },
                "wrapper-col": { span: 18 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "登录名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.loginUser.loginName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginUser.loginName) = $event)),
                        allowClear: true,
                        placeholder: "请输入用户名"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "密码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.loginUser.password,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginUser.password) = $event)),
                        type: "password",
                        allowClear: true,
                        placeholder: "请输入密码"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "验证码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.loginUser.captcha,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginUser.captcha) = $event)),
                        allowClear: true,
                        placeholder: "请输入验证码"
                      }, null, 8, ["value"]),
                      _createVNode(_component_a_image, {
                        width: 160,
                        src: _ctx.loginUser.base64,
                        placeholder: true,
                        preview: false,
                        style: {"border":"1px solid #EBEEF5","cursor":"pointer","margin-top":"5px"},
                        onClick: _ctx.pullCaptcha
                      }, null, 8, ["src", "onClick"]),
                      _createVNode(_component_a_spin, { spinning: _ctx.loadingCaptcha }, null, 8, ["spinning"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        style: {"width":"100px","margin-left":"185px"},
                        onClick: _ctx.login
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("登 录")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_the_footer)
    ]),
    _: 1
  }))
}